import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

export const TutorReportFilterSlice = createSlice({
  name: "TutorReportFilterSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    TutorReportFilter: (state, _: PayloadAction<any>) => {
      state.isLoading = true;
    },
    successTutorReportFilter: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureTutorReportFilter: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearTutorReportFilter: (state) => {
      state.data = {};
    },
  },
});

export const {
  TutorReportFilter,
  failureTutorReportFilter,
  successTutorReportFilter,
  clearTutorReportFilter,
} = TutorReportFilterSlice.actions;

export default TutorReportFilterSlice.reducer;
